import "react";
import { clsx } from "../../../clsx/dist/clsx.es.js";
import { getPickersFadeTransitionGroupUtilityClass } from "./pickersFadeTransitionGroupClasses.es.js";
import { j as jsxRuntimeExports } from "../../../react/jsx-runtime.es.js";
import styled from "../../material/styles/styled.es.js";
import TransitionGroup from "../../../react-transition-group/esm/TransitionGroup.es.js";
import useThemeProps from "../../material/styles/useThemeProps.es.js";
import useTheme from "../../material/styles/useTheme.es.js";
import Fade from "../../material/Fade/Fade.es.js";
import composeClasses from "../../utils/composeClasses/composeClasses.es.js";
const useUtilityClasses = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getPickersFadeTransitionGroupUtilityClass, classes);
};
const PickersFadeTransitionGroupRoot = styled(TransitionGroup, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})({
  display: "block",
  position: "relative"
});
function PickersFadeTransitionGroup(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: "MuiPickersFadeTransitionGroup"
  });
  const {
    children,
    className,
    reduceAnimations,
    transKey
  } = props;
  const classes = useUtilityClasses(props);
  const theme = useTheme();
  if (reduceAnimations) {
    return children;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersFadeTransitionGroupRoot, {
    className: clsx(classes.root, className),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Fade, {
      appear: false,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        appear: theme.transitions.duration.enteringScreen,
        enter: theme.transitions.duration.enteringScreen,
        exit: 0
      },
      children
    }, transKey)
  });
}
export {
  PickersFadeTransitionGroup
};
//# sourceMappingURL=PickersFadeTransitionGroup.es.js.map
